import React from 'react';
import { motion } from 'framer-motion';
import { BonusCard } from './BonusCard';
const bonuses = [{
  number: 1,
  title: 'Desodorantes Naturales Artesanales',
  value: 47,
  description: 'Aprende a formular desodorantes naturales funcionales y seguros. Una línea complementaria perfecta para aumentar tu ticket promedio. Porque quien compra jabones… también compra cuidado personal.'
}, {
  number: 2,
  title: 'Cosmética Sólida Profesional',
  value: 57,
  description: 'Shampoo sólido. Acondicionador sólido. Bálsamos. La tendencia ecológica que está explotando en ventas.'
}, {
  number: 3,
  title: 'Maquillaje Natural Artesanal',
  value: 67,
  description: 'Bases naturales. Labiales artesanales. Productos sin químicos agresivos. Una categoría premium que eleva tu marca.'
}, {
  number: 4,
  title: 'Cuidado de la Piel (Skin Care Natural)',
  value: 77,
  description: 'Cremas. Exfoliantes. Mascarillas. Porque una clienta satisfecha quiere una rutina completa.'
}, {
  number: 5,
  title: 'Velas Artesanales Aromáticas',
  value: 47,
  description: 'Velas decorativas y aromáticas. El complemento perfecto para vender kits y combos. Más productos. Más ingresos.'
}, {
  number: 6,
  title: 'Certificado de Reconocimiento',
  value: 29,
  description: 'Un certificado digital que avala tu formación. Perfecto para mostrar en redes y generar confianza.'
}, {
  number: 7,
  title: 'Membresía VIP',
  value: 97,
  description: 'Acceso de por Vida + Actualizaciones Gratuitas. Cada vez que agreguemos nuevas recetas o mejoras… Las recibes sin pagar un centavo extra. Sin renovaciones. Sin mensualidades. Sin letra pequeña.'
}];
export function Bonuses() {
  return <section className="w-full bg-[var(--bg-dark)] py-20 px-4" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-22">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[var(--text-light)] mb-6" data-id="element-23">
            Pero Espera… Esto Se Pone
            <br data-id="element-24" />
            <span className="text-[var(--accent-orange)]" data-id="element-25">
              Mucho Más Grande
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-[var(--text-gray)] max-w-3xl mx-auto" data-id="element-26">
            Porque cuando alguien decide emprender… No solo quiere hacer
            jabones.
            <span className="text-[var(--text-light)] font-bold" data-id="element-27">
              {' '}
              Quiere tener un negocio completo.
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-28">
          {bonuses.map((bonus, index) => <BonusCard key={bonus.number} number={bonus.number} title={bonus.title} value={bonus.value} description={bonus.description} delay={index * 0.1} data-id="element-29" />)}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} data-id="element-30">
          <p className="text-xl md:text-2xl text-[var(--text-gray)] mb-4" data-id="element-31">
            Y por eso decidí incluir algo que, honestamente,
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[var(--accent-orange)]" data-id="element-32">
            podría venderse por separado.
          </p>
        </motion.div>
      </div>
    </section>;
}